// extracted by mini-css-extract-plugin
module.exports = {"withoutDialog":"MrA9b9","withDialog":"VxrFiJ"};